var AdaptiveImage = require("../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "src/assets/web/images/action_slide_upload_new_items_en.png",
    width: 1893,
    height: 867
});